import React from "react";

function LandingFooter() {
    return (
        <footer className="mt-16 border-t border-[#e5e5e5] bg-[#f9fafb]">
            <div className="max-w-[1200px] mx-auto px-4 py-10 lg:px-0">
                <div className="grid gap-8 md:grid-cols-[2fr,1.2fr,1.2fr,1.5fr]">
                    <div className="space-y-4">
                        <div className="flex items-center gap-1 font-bold text-[20px]">
                            <span className="text-[#147F26]">Agroland.kz</span>
                        </div>
                        <p className="text-sm text-[#6b7280] max-w-sm">
                            Цифровая экосистема для агробизнеса: управление, торговля и
                            маркетплейс для фермеров, поставщиков и покупателей.
                        </p>
                        <div className="flex gap-3 mt-4">
                            <span className="h-8 w-8 rounded-full bg-[#147F26]/10" />
                            <span className="h-8 w-8 rounded-full bg-[#147F26]/10" />
                            <span className="h-8 w-8 rounded-full bg-[#147F26]/10" />
                        </div>
                    </div>

                    <div>
                        <h4 className="mb-3 text-sm font-semibold text-[#111827]">
                            Компания
                        </h4>
                        <ul className="space-y-1.5 text-sm text-[#4b5563]">
                            <li>О нас</li>
                            <li>История</li>
                            <li>Контакты</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="mb-3 text-sm font-semibold text-[#111827]">
                            Карьера
                        </h4>
                        <ul className="space-y-1.5 text-sm text-[#4b5563]">
                            <li>Вакансии</li>
                            <li>Стажировки</li>
                            <li>Жизнь в Agroland</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="mb-3 text-sm font-semibold text-[#111827]">
                            Продукты
                        </h4>
                        <ul className="space-y-1.5 text-sm text-[#4b5563]">
                            <li>AgroX</li>
                            <li>AgroTrade</li>
                            <li>AgroMarket</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-8 flex flex-col gap-3 border-t border-[#e5e7eb] pt-4 text-xs text-[#6b7280] md:flex-row md:items-center md:justify-between">
                    <p>© {new Date().getFullYear()} Agroland.kz. Все права защищены.</p>
                    <div className="flex flex-wrap gap-3">
                        <span>Политика конфиденциальности</span>
                        <span>Пользовательское соглашение</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default LandingFooter;

